var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"display":"none"},attrs:{"xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.svgNames),function(svg,index){return _c('symbol',{key:index,attrs:{"id":svg}},[_c(svg,{tag:"component"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }